import { Tooltip } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import NovoFluxoApp from 'app/Workflow/MinhasTarefas/Apps/NovoFluxoApp';
import React from 'react';

class ReportBug extends XAPPComponent {

    render() {
        var { tipo } = this.props;
        if (tipo === undefined) {
            tipo = "icon";
        }

        switch (tipo.toUpperCase()) {
            case "ICON1":
                return (

                    <div className="flex flex-row">
                        <Tooltip
                            title={"Satisfeito"}
                        >
                            <NovoFluxoApp
                                xappRouteParams={this.props.xappRouteParams}
                                type={"Icon"}
                                className={"text-grey"}
                                icon={"satisfied"}
                                tipo={100}
                                showDialog={true}
                            />
                        </Tooltip>
                        <Tooltip
                            title={"Insatisfeito"}
                        >
                            <NovoFluxoApp
                                xappRouteParams={this.props.xappRouteParams}
                                type={"Icon"}
                                icon={"dissatisfied"}
                                className={"text-grey"}
                                tipo={100}
                                showDialog={true}
                            />
                        </Tooltip>
                    </div>
                );
            case "BUTTON1":
                return (
                    <div className="flex">
                        <XAPPButton
                            className="text-white"
                            type="Button"
                            icon="dissatisfied"
                            fluxo="1"
                            variant="contained"
                            color="secondary"
                            label="Reportar erro"
                            iconProps="mr-8"
                        />
                    </div>
                );
            default:
                return (
                    <div></div>
                )
        }

    }
}

export default ReportBug;
